/**
 * The one place that picks a deal's systems diagram by product, so the deal page and the SOW
 * export can never draw different pictures:
 * - Maxio: left-to-right logo diagram derived from the Maxio answers.
 * - Rillet: the same logo diagram from the deal's tech-stack systems.
 * - Everything else: the hub-and-spoke tech-stack diagram.
 */
import { buildMaxioLandscape, isMaxioProductKey } from './maxio-landscape.js';
import { buildRilletLandscape, isRilletProductKey } from './rillet-landscape.js';
import { buildTechStackLandscape } from './tech-stack.js';
export function buildDealSystemLandscape(input) {
    if (isMaxioProductKey(input.productKey))
        return buildMaxioLandscape(input.answers);
    if (isRilletProductKey(input.productKey))
        return buildRilletLandscape(input.systems());
    return buildTechStackLandscape(input.systems(), { hubName: input.hubName });
}
//# sourceMappingURL=deal-landscape.js.map